<template>
  <div v-if="alertText && dismissCountDown > 0" class="col-auto alertPosition alertVue">
    <b-alert :show="computedDismissCountDownChanged" dismissible :variant="alertVariant" fade @dismissed="resetAlert">
      <div class="row">
        <div class="col">
          <h5 class="d-inline-flex">{{ alertTitle }}</h5>
          <!-- <p>{{ alertText }}</p> -->
          <p v-safe-html="alertText"></p>
        </div>
      </div>

      <template slot="dismiss">
        <span aria-hidden="true">
          <img src="/src/images/icon-modal-close.svg" alt="icon-modal-close" loading="lazy" />
        </span>
      </template>
    </b-alert>
  </div>
</template>

<script>
import Vue from "vue";
import { AlertPlugin } from "bootstrap-vue";
Vue.use(AlertPlugin);

export default {
  name: "BaseAlert",
  computed: {
    alertTitle: {
      get() {
        return this.$store.getters.getAlertTitle;
      },
    },
    alertText: {
      get() {
        return this.$store.getters.getAlertText;
      },
    },
    alertVariant: {
      get() {
        return this.$store.getters.getAlertVariant;
      },
    },
    dismissCountDown: {
      get() {
        return this.$store.getters.getDismissCountDown;
      },
      set(value) {
        this.$store.commit("setDismissCountDown", value);
      },
    },
    computedDismissCountDownChanged() {
      const dismissCountDown = this.$store.getters.getDismissCountDown;
      if (dismissCountDown === 0) {
        this.resetAlert();
      }
      return dismissCountDown;
    },
  },
  methods: {
    resetAlert() {
      this.$store.commit("setAlertText", "");
      this.$store.commit("setAlertTitle", "");
      this.$store.commit("setAlertVariant", "");
      this.$store.commit("setDismissCountDown", 0);
    },
  },
};
</script>

<style scoped></style>
